import { WorkflowProcessType } from '@app-store'
import {
  ENTITY_NAME,
  NAMESPACES,
  PHARMACY_TRIAGE_CONSTANTS,
} from '../../../utils/constants'
import {
  editEntityData,
  editEntityDataEmbeddedAPI,
  getEntityDataByIdEmbedded,
} from '../../../apis/entityData.api'

export interface SaveCaseSummaryOutcomeParams {
  outcomeId: string | number
  outcomeReasonId: string | number
  caseId?: string | number
  workflowDefinition?: WorkflowProcessType | null
}

export const saveCaseSummaryOutcome = async ({
  outcomeId,
  outcomeReasonId,
  caseId,
  workflowDefinition,
}: SaveCaseSummaryOutcomeParams) => {
  const caseEntityName = workflowDefinition?.global_variables?.entity_name ?? ''
  const caseEntityId = Number(workflowDefinition?.global_variables?.entity_id)
  const closeData = workflowDefinition?.global_variables?.case_management?.close
  const summaryEntityId = Number(closeData?.entity_id)
  const summaryLayoutId = Number(closeData?.layout_id)

  if (!summaryEntityId || !summaryLayoutId || !caseId) {
    return
  }

  const outcomeFields = {
    [PHARMACY_TRIAGE_CONSTANTS.OUTCOME]: {
      id: Number(outcomeId),
      _state: NAMESPACES.CHANGED,
    },
    [PHARMACY_TRIAGE_CONSTANTS.OUTCOME_REASON]: {
      id: Number(outcomeReasonId),
      _state: NAMESPACES.CHANGED,
    },
  }

  const summaryResponse = await getEntityDataByIdEmbedded(
    caseEntityName,
    caseEntityId,
    [ENTITY_NAME.CASE_SUMMARY],
    Number(caseId)
  )
  const summaryId = summaryResponse?.data?.[ENTITY_NAME.CASE_SUMMARY]?.id

  if (!summaryId) {
    await editEntityDataEmbeddedAPI(
      caseEntityName,
      caseId,
      { [ENTITY_NAME.CASE_SUMMARY]: outcomeFields },
      [ENTITY_NAME.CASE_SUMMARY]
    )
    return
  }

  await editEntityData(
    closeData?.entity_name ?? ENTITY_NAME.CASE_SUMMARY,
    summaryEntityId,
    summaryLayoutId,
    { id: summaryId, ...outcomeFields },
    summaryId
  )
}
